import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import ShareButtons from '../components/ShareButtons';
import CommentsSection from '../components/CommentsSection';
import { getPost } from '../lib/api';

function PostDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    getPost(slug)
      .then((data) => setPost(data.post))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="page page--narrow">
        <h1>Artículo no encontrado</h1>
        <Link to="/que-leer">Volver a Qué leer</Link>
      </div>
    );
  }

  if (!post) return null;

  return (
    <article className="page page--narrow">
      <Seo
        title={post.seo_title || post.title}
        description={post.meta_description || post.excerpt}
        image={post.cover_url}
      />

      <h1>{post.title}</h1>
      {post.cover_url && <img src={post.cover_url} alt={post.title} style={{ borderRadius: 8, marginBottom: '1rem' }} />}

      <div className="rich-content" dangerouslySetInnerHTML={{ __html: post.content || '' }} />

      <ShareButtons title={post.title} />

      <CommentsSection contentType="post" contentId={post.id} />
    </article>
  );
}

export default PostDetail;
